export const zIndex = {
  Default: 0,
  Button: 1,
  Calendar: 30,
  Select: 40,
  Header: 1000,
  Modal: 2000,
  Cookie: 2001
};
